import googlePlacesAddressNormalizer from 'google-places-address-normalizer'
import { compose, defaultProps, withHandlers, withState } from 'recompose'

import withGooglePlaces from 'components/HOCs/WithGooglePlaces'

import { InnerProps, Props } from './types'

const enhance = compose<InnerProps, Props>(
  defaultProps({
    onChange: () => {},
    onAutoCompleteSelect: () => {},
  }),
  withGooglePlaces,
  withState('addressAutoCompleteOptions', 'setAddressAutoCompleteOptions', null),
  withState('autoCompleteTime', 'setAutoCompleteTime', Date.now()),
  withHandlers({
    handleDetailsResults: ({ onAutoCompleteSelect, validateForm }) => (place, status) => {
      /* istanbul ignore else */
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const normalizedAddress = googlePlacesAddressNormalizer(place.address_components)

        onAutoCompleteSelect({
          street1: normalizedAddress.address || '',
          street2: '',
          city: normalizedAddress.city || '',
          state: normalizedAddress.state || '',
          stateAbbreviation: normalizedAddress.state_abbreviation || '',
          zipCode: normalizedAddress.postal_code || '',
        })

        if (validateForm) {
          validateForm()
        }
      }
    },
    handleClickOutside: ({ setAddressAutoCompleteOptions }) => () => {
      setAddressAutoCompleteOptions(null)
    },
    handleStreamChange: ({
      onChange,
      autoComplete,
      autoCompleteTime,
      setAddressAutoCompleteOptions,
      setAutoCompleteTime,
    }) => e => {
      onChange(e)
      const address = e.target.value
      /* istanbul ignore else */
      if (address.length === 0) {
        setAddressAutoCompleteOptions(null)
      } else if (
        address.length >= 4 &&
        Date.now() - autoCompleteTime >= 1000 &&
        e.nativeEvent &&
        e.nativeEvent.which !== undefined
      ) {
        // e.nativeEvent.which !== undefined means the event is a user input event and not a browser autofill
        setAutoCompleteTime(Date.now())
        autoComplete?.getPlacePredictions(
          {
            componentRestrictions: {
              country: 'us',
            },
            input: address,
            types: ['address'],
          },
          (data: google.maps.places.AutocompletePrediction[]) => {
            setAddressAutoCompleteOptions(data)
          },
        )
      }
    },
  }),
  withHandlers({
    handleAutoCompleteSelect: ({
      handleDetailsResults,
      placesService,
      setAddressAutoCompleteOptions,
      setAutoCompleteTime,
    }) => (suggestion: google.maps.places.AutocompletePrediction) => {
      setAddressAutoCompleteOptions(null)
      setAutoCompleteTime(Date.now())

      // Note: for fetching zip code
      placesService.getDetails(
        {
          placeId: suggestion.place_id,
        },
        handleDetailsResults,
      )
    },
  }),
)

export default enhance
